import { motion } from "motion/react";
import { useTranslation } from '../../i18n/useTranslation';
import type { Product } from '../domain/models';
import { ProductTile } from './ProductTile';
import styles from './ProductList.module.scss';

interface ProductListProps {
  products: Product[],
}

export function ProductList(props: ProductListProps) {
  const { t } = useTranslation();

  if (props.products.length === 0) {
    return (
      <div className={ styles.noResultsBlock }>
        <div className={ styles.noResultsBlockInner }>

          <div className={ styles.noResultsBlockMessage }>
            <p>{ t('results_empty') }</p>
          </div>

        </div>
      </div>
    );
  }

  return (
    <div className={ styles.container }>

      <motion.div className={ styles.listBlock } initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, ease: 'easeOut' }}>
        <ol className={ styles.list }>
          { props.products.map(product => (
            <li key={ product.id } className={ styles.listItem }>
              <ProductTile key={ product.id } product={ product } />
            </li>
          )) }
        </ol>
      </motion.div>

    </div>
  );
}
